export default class personalGoods{
    constructor(){
        this._aSideData = [];
        this._cSideData = [];
        this._selected = [];
        this._parent = null;
        this._pictures = [];
        this.machineInfo = null;
    }

    setParent(parent){
        this._parent = parent;
    }
    
    init(data){
        // 接口可能缺少 "A面"/"C面" 字段，需用可选链防御，避免读取 undefined.length 报错
        if(data["A面"]?.length > 0){
            this._aSideData = data["A面"];
        }
        if(data["C面"]?.length > 0){
            this._cSideData = data["C面"];
        }
        // 设备类型为平板、台式机、手机的数据
        if(data["machineInfo"]){
          this.machineInfo = data["machineInfo"];
        }
    }  
    
    setPictures(data){
        this._pictures = data;
    }
}